// NPM Imports
import React, { Component } from "react";
import { connect } from "react-redux";

// Components Imports
import QuotationTopbarInfo from "./QuotationTopbarInfo";
// import QuotationTopbarBtns from "./QuotationTopbarBtns";
import QuotationTopBarV2 from "../QuotationTopBarV2";
import QuotationTopBarV3 from "../QuotationTopBarV3";
import StatusDropdown from "./StatusDropdown";
import { GlobalUtils } from "../../utils";

const { readDataFromLocalStorage } = GlobalUtils;

// Declarations
const FORM = "form";

// TO_ASH: Change the component to pure func
class QuotationTopbar extends Component {
  state = {};

  render() {
    return (
      <div
        data-test="quotationtopbar-documentdetails-topbar-section"
        className="documentdetails-topbar-section">
        <QuotationTopbarInfo {...this.props} />
        {/* <QuotationTopbarBtns /> */}
        <QuotationTopBarV3 />
        <QuotationTopBarV2 />
        {/* Status dropdown */}
        <StatusDropdown
          currentStatus={this.props.documentStatus}
          currentTag={this.props.documentTag}
          docId={this.props.docId}
          source="Document"
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {
    document: {
      isLocked,
      template_type: templateType,
      documentStatus,
      documentTag,
      id,
      scope: { write, fill } = {},
      stage,
    } = {},
    docRecipientList,
  } = state.DocumentStore;

  const isTemplateTypeForm = templateType === FORM;

  const CURRENT_USER = readDataFromLocalStorage("revvsalesUser");
  // For internal user
  const currentUserIsFiller = docRecipientList.some(
    item =>
      item.user &&
      item.user.id === CURRENT_USER.id &&
      item.recipient_type === "FILLER",
  );

  let lockedInStage = true;
  if (
    stage === "DRAFT" ||
    (stage === "SENT_FOR_FILLING" && currentUserIsFiller)
  ) {
    lockedInStage = false;
  }

  return {
    isLocked: (isLocked && !(write || fill)) || lockedInStage,
    isTemplateTypeForm,
    documentStatus,
    documentTag,
    docId: id,
  };
};

export default connect(
  mapStateToProps,
  null,
)(QuotationTopbar);



// WEBPACK FOOTER //
// ./src/components/QuotationTopbar/QuotationTopbar.js